import { Outlet } from "react-router-dom";
import HeaderMember from "components/HeaderMember";
import Footer from "components/Footer";

const MemberLayout = () => {
    return (
        <>
            <HeaderMember />

            <div className="mt-16 min-h-[500px] text-sm">
                <Outlet />
            </div>

            <Footer />
        </>
    )
}

export default MemberLayout
